import { useCallback } from 'react';
import type { BoundaryTerritoryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import {
  createRequestFromBoundaryTerritoryGroupSettings, getBoundaryTerritoryGroupMatchupRequest,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.factory';
import { ensureBeValidBoundaryTerritoryGroupId } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.helpers';
import type { BoundaryTerritoryGroupDefinition } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.repository';
import { useGetBoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';

export const useBoundaryTerritoryGroupDefinition = () => {
  const { getBoundaryTerritoryGroupById } = useGetBoundaryTerritoryGroup();

  return useCallback(({
    boundaryTerritoryGroupId,
  }: Readonly<{
    boundaryTerritoryGroupId: BoundaryTerritoryGroupId;
  }>): BoundaryTerritoryGroupDefinition | undefined => {
    const selectedBoundaryTerritoryGroup = getBoundaryTerritoryGroupById(boundaryTerritoryGroupId);

    if (!selectedBoundaryTerritoryGroup) {
      return undefined;
    }

    return {
      boundary_territory_group_id: ensureBeValidBoundaryTerritoryGroupId(selectedBoundaryTerritoryGroup),
      boundary_group_id: selectedBoundaryTerritoryGroup.boundaryGroupId,
      matchings: getBoundaryTerritoryGroupMatchupRequest(selectedBoundaryTerritoryGroup.matchings),
      settings: createRequestFromBoundaryTerritoryGroupSettings(selectedBoundaryTerritoryGroup.settings),
    };
  }, [getBoundaryTerritoryGroupById]);
};
